module.exports = __webpack_public_path__ + "img/flat_work3.7037c249.jpg";